import { render, staticRenderFns } from "./BindAccountDialog.vue?vue&type=template&id=2e3ce742&scoped=true"
import script from "./BindAccountDialog.vue?vue&type=script&lang=ts"
export * from "./BindAccountDialog.vue?vue&type=script&lang=ts"
import style0 from "./BindAccountDialog.vue?vue&type=style&index=0&id=2e3ce742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ce742",
  null
  
)

export default component.exports